export default "__VITE_PUBLIC_ASSET__334314cc__"